import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../../i18n";
import api from "../../lib/api";
import ProductCard from "../ProductCard";
import { Reveal } from "../motion";
import { BerryBranch } from "../Botanicals";

const ShopPreview = () => {
  const { t } = useLang();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/shop/products").then(({ data }) => setProducts(data)).catch(() => {});
  }, []);

  const featured = products.filter((p) => ["book_paperback", "ebook_moodfood", "program_reset21"].includes(p.lookup_key));

  return (
    <section id="shop" data-testid="shop-preview" className="relative overflow-hidden max-w-[1400px] mx-auto px-6 lg:px-10 py-28 lg:py-36">
      <BerryBranch className="pointer-events-none absolute top-16 right-4 w-28 text-coral/30 animate-sway hidden lg:block" />
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div className="max-w-xl">
            <p className="text-primary/70 text-xs uppercase tracking-[0.25em] mb-6">{t("nav.shop")}</p>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tightest text-foreground">{t("shop.title")}</h2>
            <p className="mt-5 text-foreground/65 font-light">{t("shop.sub")}</p>
          </div>
          <Link to="/shop" data-testid="shop-viewall" className="group flex items-center gap-2 text-primary text-sm font-medium whitespace-nowrap">
            {t("shop.viewAll")}
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </Reveal>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {featured.map((p, i) => (
          <Reveal key={p.lookup_key} delay={i * 0.08}>
            <ProductCard product={p} />
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default ShopPreview;
